import React from "react";
import Icon from "../../utils/Icon";
import ConditionalRender from "../../../ConditionalRender";

const ApiError = ({
    error,
    greyIcon=false,
    errorAction={},
    ...props
}) => {
    const ERROR_CODES = {
        '413': {description: 'The request is too large to handle. Please adjust your selection and try again.', startOver: true},
        '500': {description: 'It might be incomplete or incorrect. Please check and try again. If the issue persists, contact support.'}
    }
    const errorConfig = ERROR_CODES[error.status_code] || null;
    return (
        <div style={{margin: '87px auto', maxWidth: 419, textAlign: 'center'}}>
            <div>
                <Icon name={greyIcon ? "GreyNotFound" : "NotFound"}/>
                <div className='text_error_message bold' style={{paddingTop: 20}}><span style={{color: '#282A2C'}}>{error.status_code}</span> Oops!</div>
                <ConditionalRender if={error.message}>
                    <div className='text_error_message' style={{color: '#282A2C', paddingTop: 8}}>{error.message}</div>
                </ConditionalRender>
                <ConditionalRender if={errorConfig?.description}>
                    <div className='text_error_message' style={{paddingTop: 8}}>{errorConfig?.description}</div>
                </ConditionalRender>
                <ConditionalRender if={errorConfig?.startOver && Object.keys(errorAction).length > 0}>
                    <div className="text_link hover_under_line" style={{marginTop: 10}} onClick={errorAction.actionCallback}>{errorAction.actionName}</div>
                </ConditionalRender>
            </div>
        </div>
    )
}
export default ApiError